module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-3"
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n\t\t")], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Expense")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": _vm.$route.params.allModuleId ? _vm.$route.params.allModuleId : '',
      "jobSeriesBanner": _vm.Filter.AssNo ? _vm.Filter.AssNo : '',
      "bannerClientName": _vm.Filter.TPTClient ? _vm.Filter.TPTClient : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('Splitmerge-Summary', {
    staticClass: "mt-2",
    attrs: {
      "SM_Status": 2,
      "title": 'All Container Track - ',
      "SM_all_module_id": _vm.allModuleId,
      "SM_jb_series": _vm.Filter.AssNo
    }
  }), _vm._v(" "), ((_vm.allpurchasesList.length > 0 && _vm.Filter.finalBillingCompleted == '0') ||
    ((_vm.Filter.finalBillingCompleted == '1') &&
      _vm.allpurchasesList[0].closedOverseasStatus == 'Overseas Closed' &&
      _vm.allpurchasesList[0].billingType == 'Overseas Billing')) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "outline-dark"
    },
    on: {
      "click": _vm.showQuotation
    }
  }, [_vm._v("\n\t\t\t\tShow Quotation\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Additional Task Request")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.otherAdditionalTask_Data,
      "fields": _vm.AdditionalTaskFields
    },
    scopedSlots: _vm._u([{
      key: "select",
      fn: function(row0) {
        return [_c('b-form-checkbox', {
          attrs: {
            "id": 'checkboxATD_' + row0.index,
            "value": row0.item
          },
          on: {
            "change": function($event) {
              _vm.addToFinalTable(row0.item)
            }
          },
          model: {
            value: (_vm.selectedATDRows),
            callback: function($$v) {
              _vm.selectedATDRows = $$v
            },
            expression: "selectedATDRows"
          }
        })]
      }
    }, {
      key: "sn",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.index + 1))])]
      }
    }, {
      key: "taskNo",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s(row2.item.AMTSeries))])]
      }
    }, {
      key: "expense",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s(row3.item.ledger))])]
      }
    }, {
      key: "expAmount",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.amount))])]
      }
    }, {
      key: "billToCustomer",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s(row5.item.scCategory))])]
      }
    }, {
      key: "sellingAmount",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s(row6.item.selling_amt))])]
      }
    }, {
      key: "remark",
      fn: function(row7) {
        return [_c('span', [_vm._v(_vm._s(row7.item.remark))])]
      }
    }, {
      key: "addedOn",
      fn: function(row8) {
        return [_c('span', [_vm._v(_vm._s(row8.item.loginTime))])]
      }
    }, {
      key: "addedBy",
      fn: function(row9) {
        return [_c('span', [_vm._v(_vm._s(row9.item.createdBy))])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Sline Payment Details")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.SlinePayment_Data,
      "fields": _vm.SlinePaymentFields
    },
    scopedSlots: _vm._u([{
      key: "select",
      fn: function(row0) {
        return [_c('b-form-checkbox', {
          attrs: {
            "id": 'checkboxSlinePayment_' + row0.index,
            "value": row0.item
          },
          on: {
            "change": function($event) {
              _vm.addToFinalTable(row0.item)
            }
          },
          model: {
            value: (_vm.selectedSlinePaymentRows),
            callback: function($$v) {
              _vm.selectedSlinePaymentRows = $$v
            },
            expression: "selectedSlinePaymentRows"
          }
        })]
      }
    }, {
      key: "sn",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.index + 1))])]
      }
    }, {
      key: "invoiceNo",
      fn: function(row2) {
        return [(row2.item.SlineUpload) ? _c('a', {
          staticStyle: {
            "color": "blue"
          },
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + (_vm.Filter.AssNo.replaceAll('/', '_')) + "/" + (row2.item.SlineUpload.replaceAll('/', '_'))))
            }
          }
        }, [_c('b', [_c('u', [_vm._v(_vm._s(row2.item.SlineInvNo))])])]) : _vm._e()]
      }
    }, {
      key: "invoiceCategory",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s(row3.item.SlineInvCategory))])]
      }
    }, {
      key: "invoiceType",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.newSlineInvType))])]
      }
    }, {
      key: "invoiceAmount",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s(row5.item.SlineInvAmount))])]
      }
    }, {
      key: "blno",
      fn: function(row14) {
        return [_c('span', [_vm._v(_vm._s(row14.item.SlineBlNo))])]
      }
    }, {
      key: "paymentMode",
      fn: function(row6) {
        return [(row6.item.SlineInvPayMode == 1) ? _c('span', [_vm._v("RTGS")]) : (row6.item.SlineInvPayMode == 2) ? _c('span', [_vm._v("Cheque")]) : _c('span')]
      }
    }, {
      key: "paymentReferenceNo",
      fn: function(row7) {
        return [_c('span', [_vm._v(_vm._s(row7.item.SlineInvPayRef))])]
      }
    }, {
      key: "paymentAmount",
      fn: function(row8) {
        return [_c('span', [_vm._v(_vm._s(row8.item.SlineInvPaidAmount))])]
      }
    }, {
      key: "paymentDate",
      fn: function(row9) {
        return [_c('span', [_vm._v(_vm._s(row9.item.SlineInvPayDate))])]
      }
    }, {
      key: "paymentStatus",
      fn: function(row10) {
        return [(row10.item.SlineInvPayStatus == 1) ? _c('span', {
          staticClass: "warning"
        }, [_vm._v("Partial")]) : (row10.item.SlineInvPayStatus == 2) ? _c('span', {
          staticClass: "success"
        }, [_vm._v("Completed")]) : _c('span', {
          staticClass: "error"
        }, [_vm._v("Pending")])]
      }
    }, {
      key: "billToShipper",
      fn: function(row11) {
        return [_c('span', [_vm._v(_vm._s(row11.item.scCategory))])]
      }
    }, {
      key: "billToShipperRemark",
      fn: function(row12) {
        return [_c('span', [_vm._v(_vm._s(row12.item.scremark))])]
      }
    }, {
      key: "addedBy",
      fn: function(row13) {
        return [_c('span', [_vm._v(_vm._s(row13.item.employeeName))])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Expense Document Details")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.ExpenseDoc_Data,
      "fields": _vm.ExpenseDocFields
    },
    scopedSlots: _vm._u([{
      key: "select",
      fn: function(row0) {
        return [_c('b-form-checkbox', {
          attrs: {
            "id": 'checkboxExpense_' + row0.index,
            "value": row0.item
          },
          on: {
            "change": function($event) {
              _vm.addToFinalTable(row0.item)
            }
          },
          model: {
            value: (_vm.selectedExpenseRows),
            callback: function($$v) {
              _vm.selectedExpenseRows = $$v
            },
            expression: "selectedExpenseRows"
          }
        })]
      }
    }, {
      key: "sn",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.index + 1))])]
      }
    }, {
      key: "expenseDate",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s(row2.item.expenseDate))])]
      }
    }, {
      key: "view",
      fn: function(row3) {
        return [(row3.item.documentLink) ? _c('a', {
          staticStyle: {
            "color": "blue"
          },
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + (_vm.Filter.AssNo.replaceAll('/', '_')) + "/" + (row3.item.documentLink.replaceAll('/', '_'))))
            }
          }
        }, [_c('b', [_c('u', [_vm._v(_vm._s(row3.item.otherDocName))])])]) : _vm._e()]
      }
    }, {
      key: "remark",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s(row6.item.docRemarks))])]
      }
    }, {
      key: "docAddingTime",
      fn: function(row7) {
        return [_c('span', [_vm._v(_vm._s(row7.item.doc_added_date))])]
      }
    }, {
      key: "docAddedBy",
      fn: function(row8) {
        return [_c('span', [_vm._v(_vm._s(row8.item.employeeName))])]
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Charges")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-responsive-lg mt-3 table-light table-bordered shadow p-3 mb-5 bg-white rounded",
    attrs: {
      "id": "quotationDetail"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "tableheaderStyling"
  }, [_c('th', [_vm._v("Select")]), _vm._v(" "), _c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Expense Type")]), _vm._v(" "), _c('th', [_vm._v("Vendor Name")]), _vm._v(" "), _c('th', [_vm._v("Vendor GST")]), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Expense No")]), _vm._v(" "), _c('th', [_vm._v("Expense Amount")]), _vm._v(" "), _c('th', [_vm._v("Expense Date")]), _vm._v(" "), _c('th', [_vm._v("Remarks")])]), _vm._v(" "), _vm._l((_vm.finalTableRows), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('b-form-checkbox', {
      attrs: {
        "id": 'checkboxFinalTable_' + index,
        "value": item
      },
      model: {
        value: (_vm.selectedFinalRows),
        callback: function($$v) {
          _vm.selectedFinalRows = $$v
        },
        expression: "selectedFinalRows"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [(item.expenseTypeAMT != undefined) ? _c('model-list-select', {
      attrs: {
        "isDisabled": "",
        "list": _vm.expenseType,
        "option-value": "expVal",
        "option-text": "expText"
      },
      model: {
        value: (item.expenseTypeAMT),
        callback: function($$v) {
          _vm.$set(item, "expenseTypeAMT", $$v)
        },
        expression: "item.expenseTypeAMT"
      }
    }) : _vm._e(), _vm._v(" "), (item.expenseTypeSline != undefined) ? _c('model-list-select', {
      attrs: {
        "isDisabled": "",
        "list": _vm.expenseType,
        "option-value": "expVal",
        "option-text": "expText"
      },
      model: {
        value: (item.expenseTypeSline),
        callback: function($$v) {
          _vm.$set(item, "expenseTypeSline", $$v)
        },
        expression: "item.expenseTypeSline"
      }
    }) : _vm._e(), _vm._v(" "), (item.expenseTypeDoc != undefined) ? _c('model-list-select', {
      attrs: {
        "isDisabled": "",
        "list": _vm.expenseType,
        "option-value": "expVal",
        "option-text": "expText"
      },
      model: {
        value: (item.expenseTypeDoc),
        callback: function($$v) {
          _vm.$set(item, "expenseTypeDoc", $$v)
        },
        expression: "item.expenseTypeDoc"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "list": _vm.$store.getters['commonDropdownMaster/getAllTallyVendorList'],
        "id": "vendor_id",
        "option-value": "vendor_id",
        "option-text": "vendor_LglNm",
        "placeholder": "Select Vendor"
      },
      on: {
        "input": function($event) {
          _vm.GstDataGet(item.vendorName, index)
        }
      },
      model: {
        value: (item.vendorName),
        callback: function($$v) {
          _vm.$set(item, "vendorName", $$v)
        },
        expression: "item.vendorName"
      }
    }), _vm._v(" "), (!item.vendorName) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.vendorNameError))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.getAllTallyVendorGstList) ? _c('model-list-select', {
      attrs: {
        "list": item.getAllTallyVendorGstList,
        "id": "vendor_add_id",
        "option-value": "vendor_add_id",
        "option-text": "Gstnumber",
        "placeholder": "Select Vendor GST"
      },
      model: {
        value: (item.vendorGst),
        callback: function($$v) {
          _vm.$set(item, "vendorGst", $$v)
        },
        expression: "item.vendorGst"
      }
    }) : _vm._e(), _vm._v(" "), (!item.vendorGst) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.vendorGstError))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.ledger != undefined) ? _c('b-form-input', {
      attrs: {
        "disabled": "",
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.ledger),
        callback: function($$v) {
          _vm.$set(item, "ledger", $$v)
        },
        expression: "item.ledger"
      }
    }) : _vm._e(), _vm._v(" "), (item.newSlineInvType != undefined) ? _c('b-form-input', {
      attrs: {
        "disabled": "",
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.newSlineInvType),
        callback: function($$v) {
          _vm.$set(item, "newSlineInvType", $$v)
        },
        expression: "item.newSlineInvType"
      }
    }) : _vm._e(), _vm._v(" "), (item.documentName != undefined) ? _c('b-form-input', {
      attrs: {
        "disabled": "",
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.documentName),
        callback: function($$v) {
          _vm.$set(item, "documentName", $$v)
        },
        expression: "item.documentName"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.AMTSeries != undefined) ? _c('b-form-input', {
      attrs: {
        "disabled": "",
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.AMTSeries),
        callback: function($$v) {
          _vm.$set(item, "AMTSeries", $$v)
        },
        expression: "item.AMTSeries"
      }
    }) : _vm._e(), _vm._v(" "), (item.SlineInvNo != undefined) ? _c('b-form-input', {
      attrs: {
        "disabled": "",
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.SlineInvNo),
        callback: function($$v) {
          _vm.$set(item, "SlineInvNo", $$v)
        },
        expression: "item.SlineInvNo"
      }
    }) : _vm._e(), _vm._v(" "), (item.AMTSeries == undefined && item.SlineInvNo == undefined) ? _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "placeholder": "Enter Invoice No"
      },
      model: {
        value: (item.invoiceNo),
        callback: function($$v) {
          _vm.$set(item, "invoiceNo", $$v)
        },
        expression: "item.invoiceNo"
      }
    }) : _vm._e(), _vm._v(" "), (!item.invoiceNo) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.invoiceNoError))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.amount != undefined) ? _c('b-form-input', {
      attrs: {
        "disabled": "",
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.amount),
        callback: function($$v) {
          _vm.$set(item, "amount", $$v)
        },
        expression: "item.amount"
      }
    }) : _vm._e(), _vm._v(" "), (item.SlineInvAmount != undefined) ? _c('b-form-input', {
      attrs: {
        "disabled": "",
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.SlineInvAmount),
        callback: function($$v) {
          _vm.$set(item, "SlineInvAmount", $$v)
        },
        expression: "item.SlineInvAmount"
      }
    }) : _vm._e(), _vm._v(" "), (item.SlineInvAmount == undefined && item.amount == undefined) ? _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "placeholder": "Enter Invoice Amount",
        "type": "number",
        "min": "1"
      },
      model: {
        value: (item.expInvoiceAmount),
        callback: function($$v) {
          _vm.$set(item, "expInvoiceAmount", $$v)
        },
        expression: "item.expInvoiceAmount"
      }
    }) : _vm._e(), _vm._v(" "), (!item.expInvoiceAmount) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.invoiceAmountError))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.doc_added_date != undefined) ? _c('b-form-input', {
      attrs: {
        "disabled": "",
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.doc_added_date),
        callback: function($$v) {
          _vm.$set(item, "doc_added_date", $$v)
        },
        expression: "item.doc_added_date"
      }
    }) : _vm._e(), _vm._v(" "), (item.SlineInvPayDate != undefined) ? _c('b-form-input', {
      attrs: {
        "disabled": "",
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.SlineInvPayDate),
        callback: function($$v) {
          _vm.$set(item, "SlineInvPayDate", $$v)
        },
        expression: "item.SlineInvPayDate"
      }
    }) : _vm._e(), _vm._v(" "), (item.loginTime != undefined) ? _c('b-form-input', {
      attrs: {
        "disabled": "",
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.loginTime),
        callback: function($$v) {
          _vm.$set(item, "loginTime", $$v)
        },
        expression: "item.loginTime"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.remark != undefined) ? _c('b-form-input', {
      attrs: {
        "disabled": "",
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.remark),
        callback: function($$v) {
          _vm.$set(item, "remark", $$v)
        },
        expression: "item.remark"
      }
    }) : _vm._e(), _vm._v(" "), (item.remark == undefined && item.docRemarks == undefined) ? _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "placeholder": "enter remark if any..."
      },
      model: {
        value: (item.slineRemark),
        callback: function($$v) {
          _vm.$set(item, "slineRemark", $$v)
        },
        expression: "item.slineRemark"
      }
    }) : _vm._e(), _vm._v(" "), (item.docRemarks != undefined) ? _c('b-form-input', {
      attrs: {
        "disabled": "",
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (item.docRemarks),
        callback: function($$v) {
          _vm.$set(item, "docRemarks", $$v)
        },
        expression: "item.docRemarks"
      }
    }) : _vm._e()], 1)])
  }), _vm._v(" "), (_vm.finalTableRows.length <= 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "font-size": "14px",
      "padding": "1%"
    },
    attrs: {
      "colspan": "10"
    }
  }, [_c('span', {
    staticClass: "warning"
  }, [_c('b', [_vm._v(" No Expenses Selected, Select the above expenses to add charges ")])])])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', [_c('b-row', {
    staticClass: "gutr"
  }, [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Job No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": "",
      "id": "jobNo",
      "name": "jobNo"
    },
    model: {
      value: (_vm.Filter.AssNo),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "AssNo", $$v)
      },
      expression: "Filter.AssNo"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Client GSTN")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientGstn",
      "name": "clientGstn"
    },
    model: {
      value: (_vm.Filter.clientGst),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientGst", $$v)
      },
      expression: "Filter.clientGst"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('label', [_vm._v("State Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.capitalizeAll,
      "id": "stateCode",
      "name": "stateCode"
    },
    model: {
      value: (_vm.Filter.stateName),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "stateName", $$v)
      },
      expression: "Filter.stateName"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "gutr"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Client Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "clientRegistrationNo",
      "name": "clientRegistrationNo"
    },
    model: {
      value: (_vm.Filter.corporateAddress),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "corporateAddress", $$v)
      },
      expression: "Filter.corporateAddress"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Pickup Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "pickupLocation",
      "name": "pickupLocation"
    },
    model: {
      value: (_vm.Filter.raisedFrom),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "raisedFrom", $$v)
      },
      expression: "Filter.raisedFrom"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Handover Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "handoverLocation",
      "name": "handoverLocation"
    },
    model: {
      value: (_vm.Filter.Handover),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "Handover", $$v)
      },
      expression: "Filter.Handover"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Factory Location")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "factorLocation",
      "name": "factorLocation"
    },
    model: {
      value: (_vm.Filter.factoryLoc),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "factoryLoc", $$v)
      },
      expression: "Filter.factoryLoc"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "gutr"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Place Of Receipt")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "placeOfReceipt",
      "name": "placeOfReceipt"
    },
    model: {
      value: (_vm.Filter.POR),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "POR", $$v)
      },
      expression: "Filter.POR"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Load Port")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "loadPort",
      "name": "loadPort"
    },
    model: {
      value: (_vm.Filter.LP),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "LP", $$v)
      },
      expression: "Filter.LP"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Final Place of Delivery")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "finalPlaceOfDel",
      "name": "finalPlaceOfDel"
    },
    model: {
      value: (_vm.Filter.FPOD),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "FPOD", $$v)
      },
      expression: "Filter.FPOD"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('label', [_vm._v("Port Of Discharge")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "portOfDischarge",
      "name": "portOfDischarge"
    },
    model: {
      value: (_vm.Filter.POD),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "POD", $$v)
      },
      expression: "Filter.POD"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "gutr"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "slineName",
      "name": "slineName"
    },
    model: {
      value: (_vm.Filter.shippingLine),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shippingLine", $$v)
      },
      expression: "Filter.shippingLine"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Vessel / Voyage")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vessel",
      "name": "vessel"
    },
    model: {
      value: (_vm.Filter.vessel),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "vessel", $$v)
      },
      expression: "Filter.vessel"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "multipleContainerType",
      "name": "multipleContainerType"
    },
    model: {
      value: (_vm.Filter.ContainerType),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "ContainerType", $$v)
      },
      expression: "Filter.ContainerType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "containerNo",
      "name": "containerNo"
    },
    model: {
      value: (_vm.Filter.Container),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "Container", $$v)
      },
      expression: "Filter.Container"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('label', [_vm._v("Weight (KGS)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.capitalizeAll,
      "id": "weight",
      "name": "weight"
    },
    model: {
      value: (_vm.Filter.weight),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "weight", $$v)
      },
      expression: "Filter.weight"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "gutr"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Bill No/ Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shippingBill",
      "name": "shippingBill"
    },
    model: {
      value: (_vm.Filter.SB),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "SB", $$v)
      },
      expression: "Filter.SB"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipper Invoice No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shippingInv",
      "name": "shippingInv"
    },
    model: {
      value: (_vm.Filter.shiperInv),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shiperInv", $$v)
      },
      expression: "Filter.shiperInv"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Shipper Invoice Date")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shippingInvDate",
      "name": "shippingInvDate"
    },
    model: {
      value: (_vm.Filter.shipperInvDate),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shipperInvDate", $$v)
      },
      expression: "Filter.shipperInvDate"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("BL No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "formatter": _vm.capitalizeAll,
      "id": "blNo",
      "name": "blNo"
    },
    model: {
      value: (_vm.Filter.blNo),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "blNo", $$v)
      },
      expression: "Filter.blNo"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [(_vm.allModuleId) ? _c('Profit-Loss', {
    attrs: {
      "PMS_fk_all_module_id": _vm.allModuleId,
      "PMS_jb_series": _vm.Filter.AssNo,
      "PMS_fk_client_id": _vm.Filter.TPTClient,
      "PLAccordianStatus": false,
      "PLAccordianButton": true
    }
  }) : _vm._e(), _vm._v(" "), _c('Assignment-Timeline', {
    attrs: {
      "TMAccordianStatus": false,
      "TMAccordianButton": true,
      "allModuleId": Number(_vm.allModuleId)
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per gutr mt-5",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [(_vm.allModuleId == this.$route.params.allModuleId) ? _c('b-button', {
    attrs: {
      "block": "",
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.submitTallyData()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.allModuleId != "" ? "Update" : "Send Data To Tally") + "\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c026c1ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/expense/singleExpenseDetails.vue
// module id = 2851
// module chunks = 0